import { MFormItem } from '../MFormItem/MFormItem';
import { MRadioGroup, MRadioGroupProps } from '../MRadioGroup/MRadioGroup';

export interface MFormRadioGroupProps extends MRadioGroupProps {
  label: string;
  align?: 'horizontal' | 'vertical';
  className?: string;
}

export const MFormRadioGroup = ({
  label,
  onChange,
  options,
  value,
  defaultValue,
  error,
  disabled,
  align,
  testId,
  className,
}: MFormRadioGroupProps) => {
  return (
    <MFormItem label={label} align='vertical' className={className} testId={testId}>
      <MRadioGroup
        align={align}
        onChange={onChange}
        options={options}
        value={value}
        defaultValue={defaultValue}
        error={error}
        disabled={disabled}
        testId={testId}
      />
    </MFormItem>
  );
};
